import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import SvgIconTwitter from "./svg/icon-twitter"
import SvgIconInstagram from "./svg/icon-instagram"
import SvgIconLinkedIn from "./svg/icon-linkedin"
import SvgIconGithub from "./svg/icon-github"

const siteFooterQuery = graphql`
  query BioQuery {
    site {
      siteMetadata {
        social {
          name
          url
        }
      }
    }
  }
`

const SiteFooter = ({
  title = "Got a things you'd like to talk about?",
  ...restProps
}) => {
  const data = useStaticQuery(siteFooterQuery)
  const {
    site: {
      siteMetadata: { social },
    },
  } = data

  const getYear = (year = 2020) => {
    if (!Date) return year
    return new Date().getFullYear()
  }

  const getImgSource = (name) => {
    switch (name) {
      case "twitter":
        return SvgIconTwitter
      case "github":
        return SvgIconGithub
      case "linkedin":
        return SvgIconLinkedIn
      case "instagram":
        return SvgIconInstagram
      default:
        return null
    }
  }

  return (
    <footer {...restProps} className="box box--invert">
      <div className="body">
        <div className="section">
          <div className="flex flex-col justify-between lg:flex-row mb-8">
            {/* Left */}
            <div className="w-full lg:w-2/3 mb-8">
              {/* Title */}
              <div className="text-2xl mb-8">{title}</div>
              {/* Contact */}
              <div className="font-heading text-2xl mb-8">
                <a
                  className="link inline-block"
                  href="mailto:max8hine@gmail.com?subject=Let's catch up&body=Hi Max,%0D%0A"
                >
                  Contact Me via Email
                </a>
              </div>
              {/* Address */}
              <div>
                <div className="font-heading mb-2">Where the magic happens</div>
                <p>Christchurch, Canterbury, New Zealand</p>
              </div>
            </div>
            {/* Right */}
            <div className="w-full lg:w-1/3 mb-8">
              <div className="flex justify-start lg:justify-end">
                {social?.map((item, index) => {
                  const SocialComponent = getImgSource(item.name)
                  if (!SocialComponent) return
                  let className = "inline-block w-12 link link--icon"
                  if (index !== 0) className += " ml-6"
                  return (
                    <a
                      className={className}
                      href={item.url}
                      target="_black"
                      key={index}
                    >
                      <SocialComponent></SocialComponent>
                    </a>
                  )
                })}
              </div>
            </div>
          </div>

          {/* small print */}
          <div className="font-sm">
            &copy; {getYear()}{" "}
            <a className="link font-normal" href="mailto:max8hine@gmail.com">
              Max Ma
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default SiteFooter
